import { render, staticRenderFns } from "./juego.vue?vue&type=template&id=69380d4c&"
import script from "./juego.vue?vue&type=script&lang=js&"
export * from "./juego.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports